import { render, staticRenderFns } from "./InformasiLainnyaDetail.vue?vue&type=template&id=568bfce0&scoped=true&"
import script from "./InformasiLainnyaDetail.vue?vue&type=script&lang=js&"
export * from "./InformasiLainnyaDetail.vue?vue&type=script&lang=js&"
import style0 from "./InformasiLainnyaDetail.vue?vue&type=style&index=0&id=568bfce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568bfce0",
  null
  
)

export default component.exports